import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataStoreService {
  /**
   * Data store object
   * @type {any}
   */
  private store: any = {};

  /**
   * Reminder component store to sync between reminder components on the same page
   * @type {any}
   */
  private reminderStore: any = {};

  constructor() {}

  /**
   * Remove the data for the given unique key
   * @param {string} key Unique key
   */
  remove(key: string, storeName: string | null = null) {
    let scope: any = this;
    if (storeName) {
      if (scope[storeName]) {
        scope[storeName][key] = undefined;
        delete scope[storeName][key];
      }
    } else this.store[key] = undefined;
  }

  /**
   * Generate a random string  of 10 characters
   * @return {string} Random string
   */
  randomString(): string {
    return Math.random().toString(36).slice(2);
  }

  /**
   * Retrieve stored data
   * @param  {string} key Storage unique key
   * @return {any}        Returns data if key has any data
   */
  retrieve(key: string, storeName: string | null = null): any {
    let scope: any = this;
    if (storeName) {
      if (scope[storeName]) return scope[storeName][key];
    } else return this.store[key];
  }

  /**
   * Get data from a store as array
   */
  retrieveStoreValues(storeName: string): Array<any> {
    let scope: any = this;
    let values: Array<any> = [];
    if (storeName && scope[storeName]) {
      let store: any = scope[storeName];
      for (let key in store) if (store.hasOwnProperty(key) && store[key]) values.push(store[key]);
      return values;
    } else return values;
  }

  /**
   * Store data with given unique key
   * @param {string} key  Unique key to identify data
   * @param {any}    data Data to store
   */
  save(key: string, data: any, storeName: string | null = null) {
    let scope: any = this;
    if (storeName) {
      if (scope[storeName]) scope[storeName][key] = data;
    } else this.store[key] = data;
  }

  /**
   * Refresh Reminder components in reminder store
   */
  updateReminderComponents() {
    let reminderComponents: any = this.retrieveStoreValues('reminderStore');
    for (let reminderComponent of reminderComponents) reminderComponent.loadReminders();
  }
}
